import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import type { ParityManagerStat } from 'lumen/models';
import ApplicationSerializer from 'lumen/serializers/application';

export default class StatSerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey(key: string) {
    if (key === 'issuestats') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('parity-manager/issuestat');
    }

    if (key === 'issuesummaries') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('parity-manager/issuesummary');
    }

    if (key === 'escalationinfos') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('parity-manager/escalationinfo');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  normalizeResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: object,
    id: string | number,
    requestType: string,
  ): { data: ParityManagerStat[]; included: ParityManagerStat[] } {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    const normalizedResponse = super.normalizeResponse(
      store,
      primaryModelClass,
      payload,
      id,
      requestType,
    ) as {
      data: ParityManagerStat[];
      included: ParityManagerStat[];
    };

    // Stat is an artificial model that is not backed by a server-side resource.
    // Overwrite data with sideloaded data (IssueStats, IssueSummaries and EscalationInfos)
    normalizedResponse.data = [...normalizedResponse.included];
    normalizedResponse.included = [];
    return normalizedResponse;
  }
}
